export default __webpack_public_path__ + "src/images/packages/saseka-tented-camp/15765ecc7f397072cf71750fb178b536-3.jpg";